import React from "react";
import { Card } from "react-bootstrap";
import { Col, CardBody } from "reactstrap";
import { Form } from "react-bootstrap";
import { Table } from "react-bootstrap";
import { ButtonGroup } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { ButtonToolbar } from "react-bootstrap";
// import DayPickerInput from "react-day-picker/DayPickerInput";
import DayPicker, { DateUtils } from "react-day-picker";
import "react-day-picker/lib/style.css";
import "./day-picker-style.css";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import GeoCoding from "./GeoCoding";
import { Breadcrumb } from "react-bootstrap";
//import { Prev } from "react-bootstrap/PageItem";
import SimpleReactValidator from 'simple-react-validator';
import { connect } from "react-redux";
import dateFormat from 'dateformat';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { delay } from "core-js";
import { logincheck } from '../../Userlogin/Userlogin'

class CreateOrder extends React.Component {

  constructor(props) {  
    super(props);
    this.state = {
      individualUserInput: [""],
      apartmentUserInput: [""],
      corporateUserInput: [""],
      AddressIdInput: [],
      customerType: "",
      customerName: "",
      customerCode: "",
      addressId: "",
      frequency: "",
      recurringday: [],
      hidecolumn: "N",
      addressLabel: "",
      fullAddress: "",
      lat: "", lng: "",
	   cashondelivery:"0",
      selectedDay: undefined,
      slot1Disable: false,
      slot2Disable: false,
      slot3Disable: false,
      slot4Disable: false,
      slot5Disable: false,
      orderDates: [
        {
          orderDate: undefined,
          slot1Capacity: 12000,
          slot2Capacity: 12000,
          slot3Capacity: 12000,
          slot4Capacity: 12000,
          slot5Capacity: 12000,
          slot1Quantity: 0,
          slot2Quantity: 0,
          slot3Quantity: 0,
          slot4Quantity: 0,
          slot5Quantity: 0,
          slot1TotalCapacity: 0,
          slot2TotalCapacity: 0,
          slot3TotalCapacity: 0,
          slot4TotalCapacity: 0,
          slot5TotalCapacity: 0
        }
      ],
      multipleDays: [],
      from: undefined,
      to: undefined,
      toggleAddress: false,
      toggleCheckAddress: false,
      editSlot: false,
      generateOrder: "N",
      slot1Capacity: 12000,
      slot2Capacity: 12000,
      slot3Capacity: 12000,
      slot4Capacity: 12000,
      slot5Capacity: 12000,
      slot1Quantity: 0,
      slot2Quantity: 0,
      slot3Quantity: 0,
      slot4Quantity: 0,
      slot5Quantity: 0,
      slot1TotalCapacity: 0,
      slot2TotalCapacity: 0,
      slot3TotalCapacity: 0,
      slot4TotalCapacity: 0,
      slot5TotalCapacity: 0,
      editIndex: 0,
      disableSubmit: true,
      zoneFlag: false,
      zone: "",
      checkedItems: new Map(),
      pricePerKL: 0,
      totalOrderPrice: 0,
      customerSelect: "",
      masterPrice: 0,
      generateButtonFlag: false,
	   paynow:0,
	   exiprydate: "",
	   chkbox: "paynow",
	   canshowtds: "none",
	   canshowaddressintdsplace: "block",
	   canshowaddressinoutsideplace: "none",
	   start_date:""

    };
    this.recurringDates = this.getInitialState();
    this.editSlotHandler = this.editSlotHandler.bind(this);
    this.createOrder = this.createOrder.bind(this);
    this.addOrder = this.addOrder.bind(this);
    this.addressFetch = this.addressFetch.bind(this);
    this.pageNavigation = this.pageNavigation.bind(this);
    this.myCallback = this.myCallback.bind(this);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
    this.submitValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
  }



  componentDidMount() {
    let userId = this.props.userId;
    let userRole = this.props.userRole;
	console.log(this.props.userfirstname)
  
	 logincheck(this.props.userId, this.props.mobiledevice).then(({ data: data }) => {
		console.log(data.status_check)
		if(data.status_check === 0) {
			this.props.history.push({ pathname: `/Logout`, state: { userId : this.props.userId , logintoken: 2 } });
		}
	}) 
	
    if (userRole === "Apartment Customer") {
      this.getApartmentID(userId);
    }
    else if (userRole === "Corporate Customer") {
      this.getCorporateID(userId);
    }
    else if (userRole === "Individual Customer") {
      this.getIndividualID(userId);
    }
    // this.fetchMasterPrice();
  }


  getApartmentID = (userId) => {
    const url = process.env.REACT_APP_NODE_ENV + "/api/apart-customer/getApartmentIdByUser/" + userId;
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => { return response.json(); }
    ).then(data => {
		
      
	  if(data.length != 0) 
		{
			this.setState({ customerCode: data[0].apartmentId, customerName: data[0].apartmentName, customerType: "Apartment_Customer" }, () => this.addressFetch(this.state.customerCode))
      
		}
		else {
			toast.dismiss()
			toast.error("Please complete your profile to proceed", {
			position: toast.POSITION.TOP_CENTER,
			autoClose: 2000
			});
			this.props.history.push({ pathname: "/aprt-customer/customer-user-create", data: "" });
			
		}
	  
	  
	  
	  
    })
  }

   getCorporateID = (userId) => {
    const url = process.env.REACT_APP_NODE_ENV + "/api/corp-customer/getCustomerIdByUser/" + userId;
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => { return response.json(); }
    ).then(data => {
		
		if(data.length != 0) 
		{
			 this.setState({ customerCode: data[0].corporateId, customerName: data[0].companyName, customerType: "Corporate_Customer" }, () => this.addressFetch(this.state.customerCode))
      
		}
		else {
			toast.dismiss()
			toast.error("Please complete your profile to proceed", {
			position: toast.POSITION.TOP_CENTER,
			autoClose: 2000
			});
			this.props.history.push({ pathname: "/corp-customer/customer-create-user", data: "" });
		}
		
     
     
    })
  }
	getIndividualID = (userId) => {
		const url = process.env.REACT_APP_NODE_ENV + "/api/indiv-customer/getIndividualIdByUser/" + userId;
		fetch(url, {
		  method: 'GET',
		  headers: {
			'Content-Type': 'application/json',
			'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
		  }
		}).then(
		  response => { return response.json(); }
		).then(data => {
			if(data.length != 0) {
				this.setState({ customerCode: data[0].individualId, customerName: data[0].name, customerType: "Individual_Customer" }, () => this.addressFetch(this.state.customerCode))
			}
			else {
				toast.dismiss()
				toast.error("Please complete your profile to proceed", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000
				});
				this.props.history.push({ pathname: "/indiv-customer/customer-create-user", data: "" });
				
			}
		  //   if (data !== "") {
		  //     this.fetchContractPrice(data[0].apartmentId)
		  //   }
		})
	  }

  fetchMasterPrice = (Id) => {
    const url5 = process.env.REACT_APP_NODE_ENV + "/api/master/findAllMasterPrice"
    fetch(url5, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => {
        if (!response.ok) throw new Error(response.status);
        else return response.json();
      }
    ).then(data => {
      if (data != null && data != undefined) {
        data.forEach((item) => {
          if (item.toDate != null) {
            item.toDate = new Date(item.toDate);
          }
        })
      }
      data = data.sort((a, b) => b.toDate - a.toDate)

      this.setState({ masterPrice: data[0].pricePerKL })
    }
    ).catch(error => console.log(error))
  }

  myCallback = (dataFromChild) => {
    this.setState({ lat: dataFromChild.lat, lng: dataFromChild.lng, fullAddress: dataFromChild.fullAddress })
  }

  /*
  handleDayClick function gets day as input from Single frequency,
  based on selected date will enable/disable slots 
  if selected date is today, will disable the slot (during the date picker selection slot and the next slot) and enable the remaining slots.
  if selected date is tomorrow and datepicker event selected after 8 pm today,then will disable the first slot of tomorrow and enable the remaining slot
  */
  handleDayClick = (day, { selected }) => {
    this.setState({ generateOrder: "N", totalOrderPrice: 0, orderDates: [], disableSubmit: true })
    if (this.state.frequency === 'Single') {
      // let currentDay =new Date("Feburary 26, 2020 21:00:00");
      let currentDay = new Date();
      let currentTime = currentDay.getHours();

      let selectedDate = day;
      this.setState({ slot1Quantity: 0, slot2Quantity: 0, slot3Quantity: 0, slot4Quantity: 0, slot5Quantity: 0, slot1TotalCapacity: 0, slot2TotalCapacity: 0, slot3TotalCapacity: 0, slot4TotalCapacity: 0, slot5TotalCapacity: 0 })
      if ((currentDay.getDate() === selectedDate.getDate()) && (currentDay.getMonth() === selectedDate.getMonth()) && (currentDay.getFullYear() === selectedDate.getFullYear())) {
		if(this.props.userRole =='Super Admin' ||  this.props.userRole =='Administrator' || this.props.userRole =='Support User' || this.props.userRole =='CRE' || this.props.userRole =='Logistics') { 
			// if (currentTime >= 0 && currentTime < 4) {
			  // this.setState({ slot1Disable: false, slot2Disable: true, slot3Disable: true, slot4Disable: false, slot5Disable: false })
			// } else if (currentTime >= 4 && currentTime < 8) {
			  // this.setState({ slot1Disable: false, slot2Disable: true, slot3Disable: true, slot4Disable: true, slot5Disable: false })
			// } else if (currentTime >= 8 && currentTime < 14) {
			  // this.setState({ slot1Disable: false, slot2Disable: true, slot3Disable: true, slot4Disable: true, slot5Disable: true })
			// } else if (currentTime >= 14) {
			  // this.setState({ slot1Disable: true, slot2Disable: true, slot3Disable: true, slot4Disable: true, slot5Disable: true })
			// }
		}else{
			if (currentTime >= 0 && currentTime < 4) {
			  this.setState({ slot1Disable: false, slot2Disable: true, slot3Disable: true, slot4Disable: false, slot5Disable: false })
			} else if (currentTime >= 4 && currentTime < 8) {
			  this.setState({ slot1Disable: false, slot2Disable: true, slot3Disable: true, slot4Disable: true, slot5Disable: false })
			} else if (currentTime >= 8 && currentTime < 14) {
			  this.setState({ slot1Disable: false, slot2Disable: true, slot3Disable: true, slot4Disable: true, slot5Disable: true })
			} else if (currentTime >= 14) {
			  this.setState({ slot1Disable: true, slot2Disable: true, slot3Disable: true, slot4Disable: true, slot5Disable: true })
			}
		}
		
      } else {
        this.setState({ slot1Disable: false, slot2Disable: false, slot3Disable: false, slot4Disable: false, slot5Disable: false })
        if (currentTime >= 20 && ((currentDay.getDate() + 1) === selectedDate.getDate()) && (currentDay.getMonth() === selectedDate.getMonth()) && (currentDay.getFullYear() === selectedDate.getFullYear())) {
          this.setState({ slot2Disable: true })
        }
      }
    }
    this.setState({
      selectedDay: selected ? undefined : day
    });
  };

  /*
  handleRecurringDayClick function gets days as input from Recurring frequency,
    will disable the dates before from date selection
  */
  handleRecurringDayClick = (day, modifiers = {}) => {

    if (modifiers.disabled) {
      return;
    }
    this.setState({ generateOrder: "N", totalOrderPrice: 0, orderDates: [], disableSubmit: true })
    this.setState({ slot1Disable: false, slot2Disable: false, slot3Disable: false, slot4Disable: false, slot5Disable: false })
    const range = DateUtils.addDayToRange(day, this.state);
    this.setState(range);
  };

  /*
  handleRecurringDayClick function gets days as input from Custom frequency,
 
  */
  handleMultipleDayClick = (day, { selected }) => {
    this.setState({ generateOrder: "N", totalOrderPrice: 0, orderDates: [], disableSubmit: true })
    this.setState({ slot1Disable: false, slot2Disable: false, slot3Disable: false, slot4Disable: false, slot5Disable: false })
    const { multipleDays } = this.state;
    if (selected) {
      const selectedIndex = multipleDays.findIndex(selectedDay =>
        DateUtils.isSameDay(selectedDay, day)
      );
      multipleDays.splice(selectedIndex, 1);
    } else {
      multipleDays.push(day);
    }

    this.setState({ multipleDays });
  };


  /*
  getInitialState function sets the datepickers from,to and custom dates to undefined
 
  */
  getInitialState() {
    return {
      from: undefined,
      to: undefined,
      enteredTo: null
    };
  }
  nextPath(path) {
    this.props.history.push(path);
  }

  /* 
    newAddressHandler will set the value for fullAddress and addressLabel for newly added address and call geocoding (google map) for new address
  */
  newAddressHandler = event => {
    switch (event.target.id) {
      case "fullAddress":
        this.setState({ fullAddress: event.target.value, toggleCheckAddress: false }); break;
      case "adlabel":
        this.setState({ addressLabel: event.target.value }); break;
      default: break;
    }
  }

  // newAddressHandler1 = event => {

  //   this.setState({ fullAddress: event.target.value });

  // };


  /* 
    newAddressClickEventHandler function call geocoding (google map) for new address
  */

  newAddressClickEventHandler = () => {
    this.setState({ toggleCheckAddress: true });
  };

  /* 
    editSlotHandler function will open edit slot model for editing order slot
  */
  editSlotHandler = value => {
    const doesToggle = this.state.editSlot;
    this.setState({ editIndex: value, editSlot: !doesToggle });
  };


  /* 
    deletSlotHandler function will delete an order
  */
  deletSlotHandler = value => {
    let totalQuantumBySlot = 0
    let count = 0
    let totalOrderPrice = 0
    let array = this.state.orderDates;
    array.splice(value, 1);
    let orderDates = [];
    this.state.orderDates.forEach((item) => {
      orderDates.push(item.orderDate)
    });
    array.map(data => {
      totalQuantumBySlot += data.slot1TotalCapacity + data.slot2TotalCapacity + data.slot3TotalCapacity + data.slot4TotalCapacity + data.slot5TotalCapacity;
    })
    totalOrderPrice = this.state.pricePerKL * (totalQuantumBySlot / 1000);
    this.setState({ totalOrderPrice: totalOrderPrice });


    this.setState({ orderDates: array, multipleDays: orderDates });
    toast.info("Order Deleted Successfully!!!", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000
    });
  }

  customerFetch() {
    if (this.state.customerType === "Apartment_Customer") {
      const url = process.env.REACT_APP_NODE_ENV + "/api/apart-customer/fetchAll/"
      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          if (!response.ok) throw new Error(response.status);
          else return response.json();
        }
      ).then(data => {
        this.setState({ apartmentUserInput: data });
		// console.log(data)
      }).catch(error => this.setState({ apartmentUserInput: [] }))
    }
    else if (this.state.customerType === "Corporate_Customer") {
      const url2 = process.env.REACT_APP_NODE_ENV + "/api/corp-customer/fetchAll/"
      fetch(url2, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          if (!response.ok) throw new Error(response.status);
          else return response.json();
        }
      ).then(data => {
        this.setState({ corporateUserInput: data });
      }).catch(error => this.setState({ corporateUserInput: [] }))
    }
    else if (this.state.customerType === "Individual_Customer") {
      const url2 = process.env.REACT_APP_NODE_ENV + "/api/indiv-customer/fetchAll/"
      fetch(url2, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          if (!response.ok) throw new Error(response.status);
          else return response.json();
        }
      ).then(data => {
        this.setState({ individualUserInput: data });
      }).catch(error => this.setState({ individualUserInput: [] }))
    }
  }

  addressFetch = (value) => {
    if (this.state.customerCode !== "") {
      const url1 = process.env.REACT_APP_NODE_ENV + "/api/address/getAddressbyCustomerId/" + value
      fetch(url1, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          if (!response.ok) throw new Error(response.status);
          else return response.json();
        }
      ).then(data => {
        let addressInputArr = [];
        addressInputArr.push({ "label": "Choose", "fullAddress": "" });

        if (data.length > 0) {
          data.forEach((x) => {
			if(x.showtocustomer === 'Yes'){
				 this.setState({canshowtds: 'block', canshowaddressintdsplace: 'none', canshowaddressinoutsideplace: 'block' })
			}
            if (x.defaultAddress != 'Yes') {
              addressInputArr.push(x)
            }
          }) 
          data.forEach((x) => {
            if (x.defaultAddress == 'Yes') {
              addressInputArr.push(x)
			  console.log(x.CPfromDate)
              this.setState({
                addressId: x.id,
                addressLabel: x.label,
                fullAddress: x.fullAddress,
                pricePerKL: x.pricePerKL,
				CPtoDate: x.CPtoDate,
				exiprydate: x.CPtoDate,
				CPfromDate: x.CPfromDate,
                generateButtonFlag: false

              });
               if (this.state.pricePerKL === null) {
				  
               if(this.props.userRole == 'Individual Customer' || this.props.userRole == 'Apartment Customer')
                {

                }
				else if(this.state.customerType === 'Individual_Customer' || this.state.customerType === 'Apartment_Customer') {
					
				}
                else {
					if((this.state.pricePerKL === null) &&  (this.state.customerType === "Individual_Customer")) {
							}else if((this.state.pricePerKL === 0) &&  (this.state.customerType === "Individual_Customer")) { 
							} else if((this.state.pricePerKL === null &&  this.state.customerType === "Apartment_Customer")) { 
							} else if((this.state.pricePerKL === 0 &&  this.state.customerType === "Apartment_Customer")) { 
							} else {
							toast.error("Order cannot be generated without contract price. Please contact backend support!!!", {
							  position: toast.POSITION.TOP_CENTER,
							  autoClose: 5000
							});
							this.setState({ generateButtonFlag: true })
							}
               }
              }
			
            }
          })
        }
        // addressInputArr.push({ "label": "NewAddress" }, { "label": "Choose", "fullAddress": "" });
		
        this.setState({ AddressIdInput: addressInputArr });
      }).catch(error => {
        let addressInputArr = [];
        // addressInputArr.push({ "label": "NewAddress" }, { "label": "Choose", "fullAddress": "" });
        addressInputArr.push({ "label": "Choose", "fullAddress": "" });
        this.setState({ AddressIdInput: addressInputArr })
      })
    }
  }

  

  addOrder = value => {
   let pay_now =this.state.paynow;
   let cash_ondelively =this.state.cashondelivery;
   let p_kl=this.state.pricePerKL;
    let noOfOrders = this.state.orderDates.length;
    let orderrand=(Math.floor(Math.random() * 100000) + 100000).toString().substring(1)+'_'+Date.now() 
    let cust_id=this.state.customerCode
    let total_price=this.state.totalOrderPrice
	let customerName_data=""
    console.log(this.props.userRole)
    if(this.props.userRole == 'Individual Customer' || this.props.userRole == 'Apartment Customer') {
      customerName_data= this.props.userfirstname+' '+this.props.userlastname
    }
    else if(this.props.userRole =='Super Admin' ||  this.props.userRole =='Administrator' || this.props.userRole =='Support User' || this.props.userRole =='CRE' || this.props.userRole =='Logistics') {  
        customerName_data=  this.state.customerName 
    }
    else {
      customerName_data=  this.state.customerName
    }
  
	let order_pending=""
    if(total_price == 0) {  order_pending= 1 } else {  order_pending= 0 } 																 
    let successStatus = [];
    let postOrderData = [];
	 if((this.props.userRole == 'Individual Customer' &&  total_price > 500000 ) ||  (this.props.userRole == 'Apartment Customer' &&  total_price > 500000)) {
        
      toast.success("Maximum online transaction limit is 5 Laks so please contact Admin to place the order", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000
      });


    } else {
	
	
	
	
	
    for (let i = 0; i < noOfOrders; i++) {
		let payedstatus = 0
		if(this.state.customerType === "Individual_Customer" && this.state.pricekl === null) { payedstatus = 0 }
		else if(this.state.customerType === "Apartment_Customer" && this.state.pricekl === null) { payedstatus = 4 }
		else if(this.state.customerType === "Corporate_Customer") { payedstatus = 4 }
	
		if(pay_now === '1' && (this.props.userRole =='Super Admin' ||  this.props.userRole =='Administrator' || this.props.userRole =='Support User' || this.props.userRole =='CRE' || this.props.userRole =='Logistics') && this.state.customerType === "Apartment_Customer") { payedstatus = 4 }
		
      postOrderData.push({
        customerId: this.state.customerCode, customerName: customerName_data,
        fullAddress: value.fullAddress, geolocationLat: value.geolocationLat, geolocationLng: value.geolocationLng, orderMasterId: this.state.customerCode + "//" + dateFormat(new Date(), 'dd-mm-yyyy'),
        customerType: this.state.customerType, addressId: value.id, orderCreateDate: dateFormat(new Date(), 'yyyy-mm-ddhh:mm:ss'), orderDeliveryDate: dateFormat(this.state.orderDates[i].orderDate, "yyyy-mm-dd"),
        slot1Capacity: this.state.orderDates[i].slot1Capacity, slot1Quantity: this.state.orderDates[i].slot1Quantity, slot1TotalCapacity: this.state.orderDates[i].slot1TotalCapacity,
        slot2Capacity: this.state.orderDates[i].slot2Capacity, slot2Quantity: this.state.orderDates[i].slot2Quantity, slot2TotalCapacity: this.state.orderDates[i].slot2TotalCapacity,
        slot3Capacity: this.state.orderDates[i].slot3Capacity, slot3Quantity: this.state.orderDates[i].slot3Quantity, slot3TotalCapacity: this.state.orderDates[i].slot3TotalCapacity,
        slot4Capacity: this.state.orderDates[i].slot4Capacity, slot4Quantity: this.state.orderDates[i].slot4Quantity, slot4TotalCapacity: this.state.orderDates[i].slot4TotalCapacity,
        slot5Capacity: this.state.orderDates[i].slot5Capacity, slot5Quantity: this.state.orderDates[i].slot5Quantity, slot5TotalCapacity: this.state.orderDates[i].slot5TotalCapacity,
        orderStatus: "Booked", orderType: this.state.frequency, cashType: cash_ondelively, pricekl: p_kl, orderrandid : orderrand, orderPending: order_pending,paymentStatus: payedstatus
      });
    }
	
	
    fetch(process.env.REACT_APP_NODE_ENV + '/api/orderChild/createOrderNew', {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(postOrderData)
    }).then(
      (response) => response.json())
      .then((data) => {
       // console.log(data)    
        if ((this.state.totalOrderPrice === 0 && this.props.userRole == 'Apartment Customer') || (this.state.totalOrderPrice === 0 && this.props.userRole == 'Individual Customer') )  
        {
              
          setTimeout(() => {
            toast.success("Admin will contact you shortly for price details`  ", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000
            });
            
               this.props.history.push({ pathname: "/transaction/order/order-pendings" });
              }, 3000);


        }
	    else if(( this.props.userRole == 'Apartment Customer' && this.state.totalOrderPrice !== 0 && pay_now === 0 )) {
				
					
					
					setTimeout(() => {
					let date_new=dateFormat(new Date(), 'yyyy-mm-dd hh:mm:ss');
					let set_Item = {
					orderdata: data, 
					post_order: postOrderData, 
					customerId: cust_id, 
					ordId : orderrand ,
					totalprice : total_price,
					paynow_status: 1,
					order_c: 'create'
					};  
					localStorage.setItem('set_data', JSON.stringify(set_Item));
					this.props.history.push({ pathname: "/transaction/order/order-payment",  orderdata: data, post_order: postOrderData, customerId: cust_id, ordId : orderrand ,totalprice : total_price  });
					}, 2000);
				  
				
		}
		else if(( this.props.userRole == 'Apartment Customer' && this.state.totalOrderPrice !== 0 && pay_now === '1' )) {
				setTimeout(() => {
           let date_new=dateFormat(new Date(), 'yyyy-mm-dd hh:mm:ss');
           let set_Item = {
            orderdata: data, 
            post_order: postOrderData, 
            customerId: cust_id, 
            ordId : orderrand ,
            totalprice : total_price,
            order_c: 'create'
           };  
           localStorage.setItem('set_data', JSON.stringify(set_Item));
            this.props.history.push({ pathname: "/transaction/order/order-payment",  orderdata: data, post_order: postOrderData, customerId: cust_id, ordId : orderrand ,totalprice : total_price  });
          }, 2000);
		}
	   
        else if( (this.props.userRole == 'Individual Customer' && this.state.totalOrderPrice !== 0 )  ||  ( this.props.userRole == 'Corporate Customer' && this.state.totalOrderPrice !== 0  && pay_now === 0)   ) {
          setTimeout(() => {
           let date_new=dateFormat(new Date(), 'yyyy-mm-dd hh:mm:ss');
           let set_Item = {
            orderdata: data, 
            post_order: postOrderData, 
            customerId: cust_id, 
            ordId : orderrand ,
            totalprice : total_price,
            order_c: 'create'
           };  
           localStorage.setItem('set_data', JSON.stringify(set_Item));
            this.props.history.push({ pathname: "/transaction/order/order-payment",  orderdata: data, post_order: postOrderData, customerId: cust_id, ordId : orderrand ,totalprice : total_price  });
          }, 2000);
        }
        else {
				if(this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole =='CRE' || this.props.userRole =='Logistics') {
							if((this.state.pricePerKL === null &&  this.state.customerType === 'Individual_Customer')) { 
										setTimeout(() => {
									toast.success("Please Create a contact price for this address", {
									  position: toast.POSITION.TOP_CENTER,
									  autoClose: 3000
									});
									
									   this.props.history.push({ pathname: "/transaction/order/order-pendings" });
									  }, 3000);
							
							}
							else if((this.state.pricePerKL === 0 &&  this.state.customerType === 'Individual_Customer')) {
								
											setTimeout(() => {
									toast.success("Please Create a contact price for this address", {
									  position: toast.POSITION.TOP_CENTER,
									  autoClose: 3000
									});
									
									   this.props.history.push({ pathname: "/transaction/order/order-pendings" });
									  }, 3000);
								
							}
							else if((this.state.pricePerKL === null &&  this.state.customerType === 'Apartment_Customer')) { 
										setTimeout(() => {
									toast.success("Please Create a contact price for this address", {
									  position: toast.POSITION.TOP_CENTER,
									  autoClose: 3000
									});
									
									   this.props.history.push({ pathname: "/transaction/order/order-pendings" });
									  }, 3000);
							
							}
							else if((this.state.pricePerKL === 0 &&  this.state.customerType === 'Apartment_Customer')) {
												setTimeout(() => {
									toast.success("Please Create a contact price for this address", {
									  position: toast.POSITION.TOP_CENTER,
									  autoClose: 3000
									});
									
									   this.props.history.push({ pathname: "/transaction/order/order-pendings" });
									  }, 3000);
								}
							else {
												setTimeout(() => {
									toast.success("Order Created Successfully!!!", {
									  position: toast.POSITION.TOP_CENTER,
									  autoClose: 3000
									});
									
									  this.pageNavigation();
									  }, 1000);
							
							}
				} else {
			
					setTimeout(() => {
					toast.success("Order Created Successfully!!!", {
					  position: toast.POSITION.TOP_CENTER,
					  autoClose: 3000
					});
					
					  this.pageNavigation();
					  }, 1000);
				}
          
        }
      })
      .catch(error => {
        toast.error("Error!!! " + error, {
          position: toast.POSITION.TOP_CENTER
        });
      })
	}

  }
  
  
  
  /* 
    createOrder function will create an order
  */
  createOrder() {


    if (this.state.orderDates.length > 0) {

      if (this.submitValidator.allValid()) {
		if(this.props.userRole == 'Individual Customer' ||  this.props.userRole == 'Apartment Customer' ) {

        }
        else {													
		if (this.state.frequency === "Recurring") {
         /* let postMailDates = { fromDate: this.state.orderDates[0].orderDate, toDate: this.state.orderDates[this.state.orderDates.length - 1].orderDate, customerId: this.state.customerCode }
          fetch(process.env.REACT_APP_NODE_ENV + '/api/mail/onOrderCreationRecurring', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postMailDates)
          }).then(data => console.log(data)) */

          let postMessageData1 = {
            fromDate: this.state.orderDates[0].orderDate, toDate: this.state.orderDates[this.state.orderDates.length - 1].orderDate, customerId: this.state.customerCode,
            phoneNumber: "8144194060"
          }

          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyAggregatorOnOrderCreationRecurring', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postMessageData1)
          })


          let postMessageData2 = {
            fromDate: this.state.orderDates[0].orderDate, toDate: this.state.orderDates[this.state.orderDates.length - 1].orderDate, customerId: this.state.customerCode,
            phoneNumber: ""
          }

          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyAggregatorOnOrderCreationRecurring', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postMessageData2)
          })
		  
		  let postMessageData4 = {
            fromDate: this.state.orderDates[0].orderDate, toDate: this.state.orderDates[this.state.orderDates.length - 1].orderDate, customerId: this.state.customerCode,
            phoneNumber: ""
          }

          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyAggregatorOnOrderCreationRecurring', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postMessageData4)
          })
		  
		  let postMessageData5 = {
            fromDate: this.state.orderDates[0].orderDate, toDate: this.state.orderDates[this.state.orderDates.length - 1].orderDate, customerId: this.state.customerCode,
            phoneNumber: ""
          }

          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyAggregatorOnOrderCreationRecurring', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postMessageData5)
          })

          let postMessageData3 = { fromDate: this.state.orderDates[0].orderDate, toDate: this.state.orderDates[this.state.orderDates.length - 1].orderDate, customerId: this.state.customerCode }

          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyCustomerOnRecurringOrder', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postMessageData3)
          })

        } else if (this.state.frequency === "Custom") {
			
			  let postMessageData1 = {
            fromDate: this.state.orderDates[0].orderDate, toDate: this.state.orderDates[this.state.orderDates.length - 1].orderDate, customerId: this.state.customerCode,
            phoneNumber: ""
          }

          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyAggregatorOnOrderCreationRecurring', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postMessageData1)
          })


          let postMessageData2 = {
            fromDate: this.state.orderDates[0].orderDate, toDate: this.state.orderDates[this.state.orderDates.length - 1].orderDate, customerId: this.state.customerCode,
            phoneNumber: ""
          }

          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyAggregatorOnOrderCreationRecurring', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postMessageData2)
          })
		  
		 /* let postMessageData4 = {
            fromDate: this.state.orderDates[0].orderDate, toDate: this.state.orderDates[this.state.orderDates.length - 1].orderDate, customerId: this.state.customerCode,
            phoneNumber: "9840515157"
          }

          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyAggregatorOnOrderCreationRecurring', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postMessageData4)
          })
		    */
		  let postMessageData5 = {
            fromDate: this.state.orderDates[0].orderDate, toDate: this.state.orderDates[this.state.orderDates.length - 1].orderDate, customerId: this.state.customerCode,
            phoneNumber: ""
          }

          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyAggregatorOnOrderCreationRecurring', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postMessageData5)
          })

          let postMessageData3 = { fromDate: this.state.orderDates[0].orderDate, toDate: this.state.orderDates[this.state.orderDates.length - 1].orderDate, customerId: this.state.customerCode }

          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyCustomerOnRecurringOrder', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postMessageData3)
          })
			
		/*	
          let postMailDates = { customerId: this.state.customerCode }
          fetch(process.env.REACT_APP_NODE_ENV + '/api/mail/onOrderCreationCustom', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postMailDates)
          }).then(data => console.log(data))
		     
          let postDates = { customerId: this.state.customerCode, phoneNumber: "8144194060" }
          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyAggregatorOnOrderCreationCustom', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postDates)
          })

          let postDates1 = { customerId: this.state.customerCode, phoneNumber: "8220716153" }
          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyAggregatorOnOrderCreationCustom', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postDates1)
          })
		  
		   let postDates3 = { customerId: this.state.customerCode, phoneNumber: "9840515157" }
          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyAggregatorOnOrderCreationCustom', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postDates3)
          })
		  
		   let postDates4 = { customerId: this.state.customerCode, phoneNumber: "8838519856" }
          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyAggregatorOnOrderCreationCustom', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postDates4)
          })

          let postDates2 = { customerId: this.state.customerCode }
          fetch(process.env.REACT_APP_NODE_ENV + '/api/message/notifyCustomerOnCustomOrder', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postDates2)
          })  */

        }
        }

        this.setState({ disableSubmit: true });

        if (this.state.addressId !== "") {
          let temp = this.state.addressId;

          let addressData = this.state.AddressIdInput.filter(x => x.id == temp)[0];
          if (addressData != undefined) {
            this.addOrder(addressData);
          }
          // this.addOrder(temp);
        }
        else {
          const { customerCode, fullAddress, lat, lng, zone, addressLabel } = this.state;
          let postAddressData = {
            associateId: customerCode,
            fullAddress: fullAddress, geolocationLat: lat, geolocationLng: lng, zone: zone, label: addressLabel
          };
          fetch(process.env.REACT_APP_NODE_ENV + '/api/address/createAddress', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postAddressData)
          }).then((response) => response.json())
            .then((data) => {
              this.addOrder(data.addressData);
            })
        }
      } else {
        this.submitValidator.showMessages();
        this.forceUpdate();
      }
    } else {
      toast.error("Please generate atleast one order to submit", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000
      });
    }
  }

  pageNavigation = () => {
    this.props.history.push({ pathname: "/transaction/order/order-list" });
  }

  /*
    handleSelectFormFields will set values for customerType adn customerCode
  */
  handleSelectFormFields = selectedOption => {
    this.setState({ generateOrder: "N", totalOrderPrice: 0, orderDates: [], disableSubmit: true })
    switch (selectedOption.id) {
      case "customerType":
        this.setState({ customerType: selectedOption.value, fullAddress: "", AddressIdInput: [], customerSelect: null }, () => { this.customerFetch(); });
        break;
      case "customerCode":
        {
          let value = selectedOption.value;
          let splitValue = value.split("&&");
          // this.setState({ customerCode: splitValue[0], customerSelect: selectedOption }, () => this.fetchContractPrice(splitValue[0]));
          this.setState({ customerCode: splitValue[0], customerSelect: selectedOption });
          this.setState({ customerName: splitValue[1] }, () => this.addressFetch(splitValue[0]));
        }
        break;
      default: break;
    }
  }
  /*
     handleFormFields will set values for frequency,address and slots fields
   */
  handleFormFields = event => {
    this.validator.showMessageFor(event.target.name)
    this.setState({ generateOrder: "N", totalOrderPrice: 0, orderDates: [], disableSubmit: true })
	// alert(event.target.id)
    switch (event.target.id) {
      case "customerType":
        this.setState({ customerType: event.target.value }, () => { this.customerFetch(); });
        break;
      case "id": {
        let value = event.target.value;
        let splitValue = value.split("&&");
        this.setState({ customerCode: splitValue[0] });
        // this.setState({ customerCode: splitValue[0] }, () => this.fetchContractPrice(splitValue[0]));
        this.setState({ customerName: splitValue[1] }, () => this.addressFetch(splitValue[0]));
      } break;
      case "frequency":
        this.setState({ slot1Disable: false, slot2Disable: false, slot3Disable: false, slot4Disable: false, slot5Disable: false })
        this.setState({ slot1Quantity: 0, slot2Quantity: 0, slot3Quantity: 0, slot4Quantity: 0, slot5Quantity: 0, slot1TotalCapacity: 0, slot2TotalCapacity: 0, slot3TotalCapacity: 0, slot4TotalCapacity: 0, slot5TotalCapacity: 0 })
        this.setState({ frequency: event.target.value, hidecolumn: "Y" });
        this.setState({ selectedDay: undefined, from: undefined, to: undefined, multipleDays: [] })
        this.validator.hideMessages();
        if (event.target.value === 'Recurring')
          this.setState({ checkedItems: new Map(), })
        break;
      case "address":
        let addressValue = event.target.value;
        let addressArr = addressValue.split("&&");
		var data_split_to=addressArr[4].split("T");
		var data_split_from=addressArr[5].split("T");
		this.setState({ label: event.target.value, tds: addressValue,exiprydate: (data_split_to === "null" ? "" : data_split_to[0] ) ,  start_date :  (data_split_from === "null" ? "" : data_split_from[0] )  })
		if (addressArr[1] != "Choose") {
				this.setState({ generateButtonFlag: false })
		}
	    var now = new Date();
		if (addressArr[1] === "NewAddress") {
          this.setState({
            addressLabel: "",
            fullAddress: "",
            addressId: "",
            toggleAddress: true,
            pricePerKL: 0,
          });
        } else {
          this.setState({
            addressId: addressArr[0],
            addressLabel: addressArr[1],
            fullAddress: addressArr[2],
          });
          if ((addressArr[3] !== "null") && (addressArr[3] !== null) && (addressArr[3] !== undefined) && (addressArr[3] !== "undefined")) {
				this.setState ({ exiprydate : data_split_to[0],  start_date : data_split_from[0], pricePerKL: addressArr[3] }) 
          } else {
            if( (this.props.userRole == 'Individual Customer') || (this.props.userRole == 'Apartment Customer')   ) {
				let price = this.state.masterPrice;  
				this.setState({ pricePerKL: 0 , generateButtonFlag: false})
            }
            else {
				  
				if( (this.props.userRole == 'Individual Customer') || (this.props.userRole == 'Apartment Customer')  )  {
				  let price = this.state.masterPrice;
				  this.setState({ pricePerKL: 0 })
				}else {
				
				if(this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole =='CRE' || this.props.userRole =='Logistics') {
						if((this.state.pricePerKL === null &&  this.state.customerType === 'Individual_Customer')) { }
						else if((this.state.pricePerKL === 0 &&  this.state.customerType === 'Individual_Customer')) { }
						else if((this.state.pricePerKL === null &&  this.state.customerType === 'Apartment_Customer')) { }
						else if((this.state.pricePerKL === 0 &&  this.state.customerType === 'Apartment_Customer')) { }
						else {
							if (addressArr[1] != "Choose") {
					 
					  toast.error("Order cannot be generated without contract price. Please contact backend support!!!", {
						position: toast.POSITION.TOP_CENTER,
						autoClose: 5000
					  });
					}
					this.setState({ pricePerKL: 0, generateButtonFlag: true, disableSubmit: true })
							
						}
					
				}
				else {
					if (addressArr[1] != "Choose") {
					 
					  toast.error("Order cannot be generated without contract price. Please contact backend support!!!", {
						position: toast.POSITION.TOP_CENTER,
						autoClose: 5000
					  });
					}
					this.setState({ pricePerKL: 0, generateButtonFlag: true, disableSubmit: true })
				}

			  }
			
		    }
          }
        }
        break;
	
	case "tds":
		// alert(event.target.value)
        let addressValue1 = event.target.value;
        let addressArr1 = addressValue1.split("&&");
		var data_split_to=addressArr1[4].split("T");
		var data_split_from=addressArr1[5].split("T");
		this.setState({ label: event.target.value, address: addressValue, tds: addressValue,exiprydate: (data_split_to === "null" ? "" : data_split_to[0] ) ,  start_date :  (data_split_from === "null" ? "" : data_split_from[0] )  })
		if (addressArr1[1] != "Choose") {
			this.setState({ generateButtonFlag: false })
		}
	    var now = new Date();
		if (addressArr1[1] === "NewAddress") {
          this.setState({
            addressLabel: "",
            fullAddress: "",
            addressId: "",
            toggleAddress: true,
            pricePerKL: 0,
          });
        } else {
          this.setState({
            addressId: addressArr1[0],
            addressLabel: addressArr1[1],
            fullAddress: addressArr1[2],
          });
          if ((addressArr1[3] !== "null") && (addressArr1[3] !== null) && (addressArr1[3] !== undefined) && (addressArr1[3] !== "undefined")) {
				this.setState ({ exiprydate : data_split_to[0],  start_date : data_split_from[0], pricePerKL: addressArr1[3] }) 
          } else {
			  
            if( (this.props.userRole == 'Individual Customer') || (this.props.userRole == 'Apartment Customer')   ) {
				// alert(1)
				let price = this.state.masterPrice;  
				this.setState({ pricePerKL: 0 , generateButtonFlag: false})
            }
            else {
				  
				if( (this.props.userRole == 'Individual Customer') || (this.props.userRole == 'Apartment Customer')  )  {
				  let price = this.state.masterPrice;
				  this.setState({ pricePerKL: 0 })
				}else {
				
				if(this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole =='CRE' || this.props.userRole =='Logistics') {
						if((this.state.pricePerKL === null &&  this.state.customerType === 'Individual_Customer')) { }
						else if((this.state.pricePerKL === 0 &&  this.state.customerType === 'Individual_Customer')) { }
						else if((this.state.pricePerKL === null &&  this.state.customerType === 'Apartment_Customer')) { }
						else if((this.state.pricePerKL === 0 &&  this.state.customerType === 'Apartment_Customer')) { }
						else {
							if (addressArr1[1] != "Choose") {
					 
					  toast.error("Order cannot be generated without contract price. Please contact backend support!!!", {
						position: toast.POSITION.TOP_CENTER,
						autoClose: 5000
					  });
					}
					this.setState({ pricePerKL: 0, generateButtonFlag: true, disableSubmit: true })
							
						}
					
				}
				else {
					if (addressArr1[1] != "Choose") {
					 
					  toast.error("Order cannot be generated without contract price. Please contact backend support!!!", {
						position: toast.POSITION.TOP_CENTER,
						autoClose: 5000
					  });
					}
					this.setState({ pricePerKL: 0, generateButtonFlag: true, disableSubmit: true })
				}

			  }
			
		    }
          }
        }
        break;
      case "slot1":
        this.setState({ slot1: event.target.value });
        break;

      case "slot1Quantity":
        const total1 = this.state.slot1Capacity * event.target.value;
        this.setState({
          slot1Quantity: event.target.value,
          slot1TotalCapacity: total1
        });
        this.setState({ slot1Quantity: event.target.value });
        break;

      case "slot1Capacity":
        const total11 = this.state.slot1Quantity * event.target.value;

        this.setState({ slot1Capacity: event.target.value, slot1TotalCapacity: total11 });
        break;

      case "slot2Quantity":
        const total2 = this.state.slot2Capacity * event.target.value;
        this.setState({
          slot2Quantity: event.target.value,
          slot2TotalCapacity: total2
        });
        this.setState({ slot2Quantity: event.target.value });
        break;

      case "slot2Capacity":
        const total22 = this.state.slot2Quantity * event.target.value;
        this.setState({ slot2Capacity: event.target.value, slot2TotalCapacity: total22 });

        break;

      case "slot3Quantity":
        const total3 = this.state.slot3Capacity * event.target.value;
        this.setState({
          slot3Quantity: event.target.value,
          slot3TotalCapacity: total3
        });
        this.setState({ slot3Quantity: event.target.value });
        break;

      case "slot3Capacity":
        const total33 = this.state.slot3Quantity * event.target.value;
        this.setState({ slot3Capacity: event.target.value, slot3TotalCapacity: total33 });

        break;

      case "slot4Quantity":
        const total4 = this.state.slot4Capacity * event.target.value;
        this.setState({
          slot4Quantity: event.target.value,
          slot4TotalCapacity: total4
        });
        this.setState({ slot4Quantity: event.target.value });
        break;

      case "slot4Capacity":
        const total44 = this.state.slot4Quantity * event.target.value;
        this.setState({ slot4Capacity: event.target.value, slot4TotalCapacity: total44 });

        break;

      case "slot5Quantity":
        const total5 = this.state.slot5Capacity * event.target.value;
        this.setState({
          slot5Quantity: event.target.value,
          slot5TotalCapacity: total5
        });
        this.setState({ slot5Quantity: event.target.value });
        break;

      case "slot5Capacity":
        const total55 = this.state.slot5Quantity * event.target.value;
        this.setState({ slot5Capacity: event.target.value, slot5TotalCapacity: total55 });

        break;
      case "recurringday":

        break;
      default:
        break;
    }
  };
  /*
     handleEditFormFields will set values for slots fields during order edit
   */
  handleEditFormFields = event => {
    const orderDatesCopy = this.state.orderDates;
    switch (event.target.id) {

      case "slot1Quantity":
        orderDatesCopy[this.state.editIndex].slot1Quantity = event.target.value;
        orderDatesCopy[this.state.editIndex].slot1TotalCapacity = orderDatesCopy[this.state.editIndex].slot1Capacity * event.target.value;
        this.setState({ orderDates: orderDatesCopy })
        break;

      case "slot1Capacity":
        orderDatesCopy[this.state.editIndex].slot1Capacity = event.target.value;
        this.setState({ orderDates: orderDatesCopy })
        break;

      case "slot2Quantity":
        orderDatesCopy[this.state.editIndex].slot2Quantity = event.target.value;
        orderDatesCopy[this.state.editIndex].slot2TotalCapacity = orderDatesCopy[this.state.editIndex].slot2Capacity * event.target.value;
        this.setState({ orderDates: orderDatesCopy })
        break;

      case "slot2Capacity":
        orderDatesCopy[this.state.editIndex].slot2Capacity = event.target.value;
        this.setState({ orderDates: orderDatesCopy })

        break;

      case "slot3Quantity":
        orderDatesCopy[this.state.editIndex].slot3Quantity = event.target.value;
        orderDatesCopy[this.state.editIndex].slot3TotalCapacity = orderDatesCopy[this.state.editIndex].slot3Capacity * event.target.value;
        this.setState({ orderDates: orderDatesCopy })
        break;

      case "slot3Capacity":
        orderDatesCopy[this.state.editIndex].slot3Capacity = event.target.value;
        this.setState({ orderDates: orderDatesCopy })

        break;

      case "slot4Quantity":
        orderDatesCopy[this.state.editIndex].slot4Quantity = event.target.value;
        orderDatesCopy[this.state.editIndex].slot4TotalCapacity = orderDatesCopy[this.state.editIndex].slot4Capacity * event.target.value;
        this.setState({ orderDates: orderDatesCopy })
        break;

      case "slot4Capacity":
        orderDatesCopy[this.state.editIndex].slot4Capacity = event.target.value;
        this.setState({ orderDates: orderDatesCopy })

        break;

      case "slot5Quantity":
        orderDatesCopy[this.state.editIndex].slot5Quantity = event.target.value;
        orderDatesCopy[this.state.editIndex].slot5TotalCapacity = orderDatesCopy[this.state.editIndex].slot5Capacity * event.target.value;
        this.setState({ orderDates: orderDatesCopy });
        break;

      case "slot5Capacity":
        orderDatesCopy[this.state.editIndex].slot5Capacity = event.target.value;
        this.setState({ orderDates: orderDatesCopy })

        break;

      default:
        break;
    }
  }

  toggleNewAddressModal = () => {
    let addressArr = this.state.AddressIdInput;
    let newAddress = { "label": this.state.addressLabel, "fullAddress": this.state.fullAddress };
    addressArr.push(newAddress)

    this.setState({ toggleAddress: false, toggleCheckAddress: false, AddressIdInput: addressArr });
  };

  toggleEditSlotModal = () => {
    let newOrderData = []
    let newOrdeDates = []
    let totalQuantumBySlot = 0;
    this.state.orderDates.map(data => {
      totalQuantumBySlot += data.slot1TotalCapacity + data.slot2TotalCapacity + data.slot3TotalCapacity + data.slot4TotalCapacity + data.slot5TotalCapacity;
      if (data.slot1TotalCapacity + data.slot2TotalCapacity + data.slot3TotalCapacity + data.slot4TotalCapacity + data.slot5TotalCapacity > 0) {
        newOrderData.push(data);

        newOrdeDates.push(data.orderDate);


      } else if ((data.slot1TotalCapacity + data.slot2TotalCapacity + data.slot3TotalCapacity + data.slot4TotalCapacity + data.slot5TotalCapacity == 0)) {
        toast.error("Your order will be delete since total quantity is 0", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000
        });
      }

      return null
    })

    if (newOrderData.length === 0) {
      this.setState({ disableSubmit: true }, () => this.setState({ orderDates: newOrderData, editSlot: false }))
    }
    else {  
	if ( (this.state.pricePerKL === null && this.props.userRole == 'Apartment Customer') || ( this.props.userRole == 'Individual Customer' &&  this.state.pricePerKL === null) ) {
        this.setState({ totalOrderPrice: 0 });
        
      }
      else {
      let totalOrderPrice = this.state.pricePerKL * (totalQuantumBySlot / 1000);
      this.setState({ totalOrderPrice: totalOrderPrice });
      this.setState({ orderDates: newOrderData, editSlot: false, multipleDays: newOrdeDates });
      }
    }

  };

  /*
   generateOrderEventHandler will generate orders based on user input
 */
  generateOrderEventHandler = () => {
    let count = 0;
    let fromRecDate, toRecDate;

    if (this.validator.allValid()) {
      this.setState({ disableSubmit: false });
      if (this.state.frequency === "Single") {
        if (this.state.selectedDay !== undefined) {
          const singleDate = this.state.selectedDay;
			var now=new Date();
					  
					var exipry_date = new Date(dateFormat(this.state.exiprydate === "null" ? "" : this.state.exiprydate, "yyyy-mm-dd"));
					var start_date1 = new Date(dateFormat(this.state.start_date === "null" ? "" : this.state.start_date, "yyyy-mm-dd"));
					
					var selected_date = new Date(dateFormat(singleDate, "yyyy-mm-dd"));
					
					
					
					if(((+start_date1 <= +selected_date) &&  (+selected_date <= +exipry_date))) 
					 {
						 
					 }
					 else {
						 
						if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole =='CRE' || this.props.userRole =='Logistics')
						{
							
							if((this.state.pricePerKL === null) &&  (this.state.customerType === "Individual_Customer")) {
							}else if((this.state.pricePerKL === 0) &&  (this.state.customerType === "Individual_Customer")) { 
							} else if((this.state.pricePerKL === null &&  this.state.customerType === "Apartment_Customer")) { 
							} else if((this.state.pricePerKL === 0 &&  this.state.customerType === "Apartment_Customer")) { 
							} else {
							  
								// let msg = 'The selected shipping address has expired or has no active days, so please contact support team.'
									// toast.error(msg, {
									// position: toast.POSITION.TOP_CENTER,
									// autoClose: 3000
									// });
									// this.setState({ disableSubmit: true });
							}
							
						} else {
						 
							if((this.state.pricePerKL === 0 &&  this.props.userRole === 'Individual Customer'))
							{
							
							}
							else if((this.state.pricePerKL === null &&  this.props.userRole === 'Individual Customer')) {
								 
							}
							else if((this.state.pricePerKL === "null" &&  this.props.userRole === 'Individual Customer')) {
								 
							}
							else if((this.state.pricePerKL === 0 &&  this.props.userRole === 'Apartment Customer')) {
								
							}
							else if((this.state.pricePerKL === null  &&  this.props.userRole === 'Apartment Customer')) {
								 
							}
							else if((this.state.pricePerKL === "null"  &&  this.props.userRole === 'Apartment Customer')) {
								 
							} 
							else {
							  
								let msg = 'The selected shipping address has expired or has no active days, so please contact support team.'
									toast.error(msg, {
									position: toast.POSITION.TOP_CENTER,
									autoClose: 3000
									});
									this.setState({ disableSubmit: true });
							}
						}
					 }

          const orderDate = {
            orderDate: singleDate,
            slot1Capacity: this.state.slot1Capacity,
            slot2Capacity: this.state.slot2Capacity,
            slot3Capacity: this.state.slot3Capacity,
            slot4Capacity: this.state.slot4Capacity,
            slot5Capacity: this.state.slot5Capacity,
            slot1Quantity: this.state.slot1Quantity,
            slot2Quantity: this.state.slot2Quantity,
            slot3Quantity: this.state.slot3Quantity,
            slot4Quantity: this.state.slot4Quantity,
            slot5Quantity: this.state.slot5Quantity,
            slot1TotalCapacity: this.state.slot1TotalCapacity,
            slot2TotalCapacity: this.state.slot2TotalCapacity,
            slot3TotalCapacity: this.state.slot3TotalCapacity,
            slot4TotalCapacity: this.state.slot4TotalCapacity,
            slot5TotalCapacity: this.state.slot5TotalCapacity
          };
          const orderDatesArr = [orderDate];
          this.setState({ orderDates: orderDatesArr, generateOrder: "Y" });
        }
        count++;
      } else if (this.state.frequency === "Recurring") {

        if ((this.state.from !== undefined && this.state.from !== null) && (this.state.to !== undefined && this.state.to !== null)) {
          var recurringDates = [];
          let index = 0;
          fromRecDate = this.state.from.toString();
          toRecDate = this.state.to.toString();

			var now=new Date();
          for (let d = new Date(fromRecDate); d <= new Date(toRecDate); d.setDate(d.getDate() + 1)) {
			  

            if (this.state.checkedItems.get("SUNDAY")) {
              if (d.getDay() === 0) {
                var orderDate = this.assignRecurringOrder(d);
                recurringDates.push(orderDate);
                count++;
              }

            }

            if (this.state.checkedItems.get("MONDAY")) {
              if (d.getDay() === 1) {
                orderDate = this.assignRecurringOrder(d);
                recurringDates.push(orderDate);
                count++;
              }

            }
            if (this.state.checkedItems.get("TUESDAY")) {
              if (d.getDay() === 2) {
                orderDate = this.assignRecurringOrder(d);
                recurringDates.push(orderDate);
                count++;
              }

            }
            if (this.state.checkedItems.get("WEDNESDAY")) {
              if (d.getDay() === 3) {
                orderDate = this.assignRecurringOrder(d);
                recurringDates.push(orderDate);
                count++;
              }

            }
            if (this.state.checkedItems.get("THURSDAY")) {
              if (d.getDay() === 4) {
                orderDate = this.assignRecurringOrder(d);
                recurringDates.push(orderDate);
                count++;
              }

            }
            if (this.state.checkedItems.get("FRIDAY")) {
              if (d.getDay() === 5) {
                orderDate = this.assignRecurringOrder(d);
                recurringDates.push(orderDate);
                count++;
              }

            }
            if (this.state.checkedItems.get("SATURDAY")) {
              if (d.getDay() === 6) {
                orderDate = this.assignRecurringOrder(d);
                recurringDates.push(orderDate);
                count++;
              }

            }

            if (this.state.checkedItems.get("ALTERNATEDAY")) {

              if (index % 2 === 0) {
                orderDate = this.assignRecurringOrder(d);
                recurringDates.push(orderDate);
                count++;
              }

            }

            if ((!this.state.checkedItems.get("SUNDAY")) && (!this.state.checkedItems.get("MONDAY")) && (!this.state.checkedItems.get("TUESDAY")) && (!this.state.checkedItems.get("WEDNESDAY")) && (!this.state.checkedItems.get("THURSDAY")) && (!this.state.checkedItems.get("FRIDAY")) && (!this.state.checkedItems.get("SATURDAY")) && (!this.state.checkedItems.get("ALTERNATEDAY"))) {

              orderDate = this.assignRecurringOrder(d);
              recurringDates.push(orderDate);
              count++;
            }
			
			
		
			
					var exipry_date = new Date(dateFormat(this.state.exiprydate === "null" ? "" : this.state.exiprydate, "yyyy-mm-dd"));
					var start_date = new Date(dateFormat(this.state.start_date === "null" ? "" : this.state.start_date, "yyyy-mm-dd"));
					
					var selected_date = new Date(dateFormat(d, "yyyy-mm-dd"));
					 if(((+start_date <= +selected_date) &&  (+selected_date <= +exipry_date))) 
					 {
						
						
							
					 }
					 else {
						 
						 
						 if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole =='CRE' || this.props.userRole =='Logistics')
						{
							if((this.state.pricePerKL === null) &&  (this.state.customerType === "Individual_Customer")) {
							}else if((this.state.pricePerKL === 0) &&  (this.state.customerType === "Individual_Customer")) { 
							} else if((this.state.pricePerKL === null &&  this.state.customerType === "Apartment_Customer")) { 
							} else if((this.state.pricePerKL === 0 &&  this.state.customerType === "Apartment_Customer")) { 
							} else {
							  
								let msg = 'The selected shipping address has expired or has no active days, so please contact support team.'
									toast.error(msg, {
									position: toast.POSITION.TOP_CENTER,
									autoClose: 3000
									});
									this.setState({ disableSubmit: true });
							}
							
						} else {
						 if((this.state.pricePerKL === 0 &&  this.props.userRole === 'Individual Customer'))
						{
							
						}
						else if((this.state.pricePerKL === null &&  this.props.userRole === 'Individual Customer')) {
							
						}
						else if((this.state.pricePerKL === "null" &&  this.props.userRole === 'Individual Customer')) {
							
						}
						else if((this.state.pricePerKL === 0 &&  this.props.userRole === 'Apartment Customer')) {
							
						}
						else if((this.state.pricePerKL === null  &&  this.props.userRole === 'Apartment Customer')) {
							
						}
						else if((this.state.pricePerKL === "null"  &&  this.props.userRole === 'Apartment Customer')) {
							
						}
						else {
							toast.dismiss()
							
						 
							 let msg = 'The selected shipping address has expired or has no active days, so please contact support team.'
									toast.error(msg, {
									position: toast.POSITION.TOP_CENTER,
									autoClose: 3000
									});
									this.setState({ disableSubmit: true });
									return false;
							}
						}
					 }
			
				
			
            index++;
          }
          this.setState({ orderDates: recurringDates, generateOrder: "Y" });
        } else {
          toast.error("Please select valid from and to date!!!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000
          });
        }

      } else if (this.state.frequency === "Custom") {
        if (this.state.multipleDays.length > 0) {
          const multipltDates = [...this.state.multipleDays];
          var multipleDays = [];
          multipltDates.forEach(
            function (day) {
				var now=new Date();
				
					
					var exipry_date = new Date(dateFormat(this.state.exiprydate === "null" ? "" : this.state.exiprydate, "yyyy-mm-dd"));
					var start_date = new Date(dateFormat(this.state.start_date === "null" ? "" : this.state.start_date, "yyyy-mm-dd"));
					
					var selected_date = new Date(dateFormat(day, "yyyy-mm-dd"));
					 if(((+start_date <= +selected_date) &&  (+selected_date <= +exipry_date))) 
					 {
						 
						
							
					 }
					 else {
						 if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole =='CRE' || this.props.userRole =='Logistics')
						{
							if((this.state.pricePerKL === null) &&  (this.state.customerType === "Individual_Customer")) {
							}else if((this.state.pricePerKL === 0) &&  (this.state.customerType === "Individual_Customer")) { 
							} else if((this.state.pricePerKL === null &&  this.state.customerType === "Apartment_Customer")) { 
							} else if((this.state.pricePerKL === 0 &&  this.state.customerType === "Apartment_Customer")) { 
							} else {
							  
								let msg = 'The selected shipping address has expired or has no active days, so please contact support team.'
									toast.error(msg, {
									position: toast.POSITION.TOP_CENTER,
									autoClose: 3000
									});
									this.setState({ disableSubmit: true });
							}
							
						} else {
								 if((this.state.pricePerKL === 0 &&  this.props.userRole === 'Individual Customer'))
								{
									
								}
								else if((this.state.pricePerKL === null &&  this.props.userRole === 'Individual Customer')) {
									
								}
								else if((this.state.pricePerKL === "null" &&  this.props.userRole === 'Individual Customer')) {
									
								}
								else if((this.state.pricePerKL === 0 &&  this.props.userRole === 'Apartment Customer')) {
									
								}
								else if((this.state.pricePerKL === null  &&  this.props.userRole === 'Apartment Customer')) {
									
								}
								else if((this.state.pricePerKL === "null"  &&  this.props.userRole === 'Apartment Customer')) {
									
								}
								else {
								 toast.dismiss()
								 let msg = 'The selected shipping address has expired or has no active days, so please contact support team.'
										toast.error(msg, {
										position: toast.POSITION.TOP_CENTER,
										autoClose: 3000
										});
										this.setState({ disableSubmit: true });
										return false;
								}
						}
					 }
			
				
					
				
				
				
		
				
				
              const orderDate = {
                orderDate: day,
                slot1Capacity: this.state.slot1Capacity,
                slot2Capacity: this.state.slot2Capacity,
                slot3Capacity: this.state.slot3Capacity,
                slot4Capacity: this.state.slot4Capacity,
                slot5Capacity: this.state.slot5Capacity,
                slot1Quantity: this.state.slot1Quantity,
                slot2Quantity: this.state.slot2Quantity,
                slot3Quantity: this.state.slot3Quantity,
                slot4Quantity: this.state.slot4Quantity,
                slot5Quantity: this.state.slot5Quantity,
                slot1TotalCapacity: this.state.slot1TotalCapacity,
                slot2TotalCapacity: this.state.slot2TotalCapacity,
                slot3TotalCapacity: this.state.slot3TotalCapacity,
                slot4TotalCapacity: this.state.slot4TotalCapacity,
                slot5TotalCapacity: this.state.slot5TotalCapacity
              };
              multipleDays.push(orderDate);
              count++;
            }.bind(this)
          );
          multipleDays = multipleDays.sort((a, b) => a.orderDate - b.orderDate)
          this.setState({ orderDates: multipleDays, generateOrder: "Y" });
        }
      }
      let totalQuantumBySlot = this.state.slot1TotalCapacity + this.state.slot2TotalCapacity + this.state.slot3TotalCapacity + this.state.slot4TotalCapacity + this.state.slot5TotalCapacity;
      let totalOrderPrice = count * this.state.pricePerKL * (totalQuantumBySlot / 1000);
      this.setState({ totalOrderPrice: totalOrderPrice });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  assignRecurringOrder(d) {
    return ({
      orderDate: new Date(d),
      slot1Capacity: this.state.slot1Capacity,
      slot2Capacity: this.state.slot2Capacity,
      slot3Capacity: this.state.slot3Capacity,
      slot4Capacity: this.state.slot4Capacity,
      slot5Capacity: this.state.slot5Capacity,
      slot1Quantity: this.state.slot1Quantity,
      slot2Quantity: this.state.slot2Quantity,
      slot3Quantity: this.state.slot3Quantity,
      slot4Quantity: this.state.slot4Quantity,
      slot5Quantity: this.state.slot5Quantity,
      slot1TotalCapacity: this.state.slot1TotalCapacity,
      slot2TotalCapacity: this.state.slot2TotalCapacity,
      slot3TotalCapacity: this.state.slot3TotalCapacity,
      slot4TotalCapacity: this.state.slot4TotalCapacity,
      slot5TotalCapacity: this.state.slot5TotalCapacity
    });
  }

   handleChange = (e) => {
    const item = e.target.name;
    const isChecked = e.target.checked;
	if(e.target.value == 'paynow') 
    {
	 	if(this.state.paynow === 0) {
			this.setState({paynow: '1'})
		}
		else {
			this.setState({paynow: 0 })
		}
    }
    this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(item, isChecked) }));

  }

  render() {
    const { from, to } = this.state;
    const modifiers = { start: this.state.from, end: this.state.to };
    const customerType = this.state.customerType;

    const selectStyles = {
      menu: base => ({
        ...base,
        zIndex: 100
      })
    };

    let newAddress = null;
    if (this.state.toggleAddress) {
      newAddress = (
        <div>
          <Modal isOpen={true}
            style={{ width: "1200px", display: "block" }}  >
            <Card style={{ width: "50rem" }}>
              <CardBody>
                <ModalHeader>New Address</ModalHeader>
                <ModalBody>
                  <Form>
                    <Form.Row>
                      <Col>
                        <Form.Group controlId="fullAddress">
                          <Form.Control placeholder="address"
                            value={this.state.fullAddress}
                            onChange={this.newAddressHandler}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Form.Row>
                    <Form.Row>
                      <Col>
                        <Form.Group controlId="adlabel">
                          <Form.Control placeholder="Title"
                            value={this.state.addressLabel}
                            onChange={this.newAddressHandler}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Form.Row>
                  </Form>
                  <Button
                    style={{ marginTop: "10px" }}
                    onClick={this.newAddressClickEventHandler}
                    variant="outline-primary" >
                    Check
                  </Button>

                  {this.state.toggleCheckAddress ? (
                    <div
                      style={{
                        height: "100%",
                        marginTop: "20px"
                      }} >
                      {navigator.onLine ? <GeoCoding address={this.state.fullAddress} callbackFromParent={this.myCallback} /> : "You Are Not Connected To Internet"}
                    </div>) : null}
                </ModalBody>
                <ModalFooter>
                  <Button variant="outline-success"
                    onClick={this.toggleNewAddressModal} >
                    Submit
                  </Button>
                  <Button variant="outline-warning"
                    onClick={this.toggleNewAddressModal} >
                    Cancel
                  </Button>
                </ModalFooter>
              </CardBody>
            </Card>
          </Modal>
        </div>
      );
    }

    let editSlots = null;
    let editIndex = this.state.editIndex;
    if (this.state.editSlot) {
      editSlots = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }} >
          <Card style={{ width: "50rem" }}>
            <CardBody>
              <ModalHeader>Order Details</ModalHeader>
              <ModalBody>
                <div align="center"><b>Order Date - {dateFormat(this.state.orderDates[editIndex].orderDate, 'dd-mm-yyyy')}</b></div>
                <Table bordered hover>
                  <thead align="center">
                    <tr>
                      <th>Slots</th>
                      <th>Quantum </th>
                      <th>Quantity</th>
                      <th>Total Quantity </th>
                    </tr>
                  </thead>
                  <tbody align="center">
                    <tr>
                      <td>Slot 1(8pm-12am)</td>
                      <td>
                        <select id='slot1Capacity' className="form-control" value={this.state.orderDates[editIndex].slot1Capacity} onChange={this.handleEditFormFields} >
                          <option value="12000">12Kl</option>
                          <option value="24000">24Kl</option>
                          <option value="36000">36Kl</option>
                          <option value="48000">48Kl</option>
                        </select>
                      </td>
                      <td>
                        <select className="form-control" id="slot1Quantity" value={this.state.orderDates[editIndex].slot1Quantity} onChange={this.handleEditFormFields}>
                          <option value="0">0</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                        </select>
                      </td>
                      <td>{this.state.orderDates[editIndex].slot1TotalCapacity}</td>
                    </tr>
                    <tr align="center">
                      <td>Slot 2(12am-4am)</td>
                      <td>
                        <select id='slot2Capacity' className="form-control" value={this.state.orderDates[editIndex].slot2Capacity} onChange={this.handleEditFormFields} >
                          <option value="12000">12Kl</option>
                          <option value="24000">24Kl</option>
                          <option value="36000">36Kl</option>
                          <option value="48000">48Kl</option>
                        </select>
                      </td>
                      <td>
                        <select className="form-control" id="slot2Quantity" value={this.state.orderDates[editIndex].slot2Quantity} onChange={this.handleEditFormFields}>
                          <option value="0">0</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                        </select>
                      </td>
                      <td>{this.state.orderDates[editIndex].slot2TotalCapacity}</td>
                    </tr>
                    <tr align="center">
                      <td>Slot 3(4am-8am)</td>
                      <td>
                        <select id='slot3Capacity' className="form-control" value={this.state.orderDates[editIndex].slot3Capacity} onChange={this.handleEditFormFields} >
                          <option value="12000">12Kl</option>
                          <option value="24000">24Kl</option>
                          <option value="36000">36Kl</option>
                          <option value="48000">48Kl</option>
                        </select>
                      </td>
                      <td>
                        <select className="form-control" id="slot3Quantity" value={this.state.orderDates[editIndex].slot3Quantity} onChange={this.handleEditFormFields}>
                          <option value="0">0</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                        </select>
                      </td>
                      <td>{this.state.orderDates[editIndex].slot3TotalCapacity}</td>
                    </tr>
                    <tr align="center">
                      <td>Slot 4(8am-2pm)</td>
                      <td>
                        <select id='slot4Capacity' className="form-control" value={this.state.orderDates[editIndex].slot4Capacity} onChange={this.handleEditFormFields} >
                          <option value="12000">12Kl</option>
                          <option value="24000">24Kl</option>
                          <option value="36000">36Kl</option>
                          <option value="48000">48Kl</option>
                        </select>
                      </td>
                      <td>
                        <select className="form-control" id="slot4Quantity" value={this.state.orderDates[editIndex].slot4Quantity} onChange={this.handleEditFormFields}>
                          <option value="0">0</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                        </select>
                      </td>
                      <td>{this.state.orderDates[editIndex].slot4TotalCapacity}</td>
                    </tr>
                    <tr align="center">
                      <td>Slot 5(2pm-8pm)</td>
                      <td>
                        <select id='slot5Capacity' className="form-control" value={this.state.orderDates[editIndex].slot5Capacity} onChange={this.handleEditFormFields} >
                          <option value="12000">12Kl</option>
                          <option value="24000">24Kl</option>
                          <option value="36000">36Kl</option>
                          <option value="48000">48Kl</option>
                        </select>
                      </td>
                      <td>
                        <select className="form-control" id="slot5Quantity" value={this.state.orderDates[editIndex].slot5Quantity} onChange={this.handleEditFormFields}>
                          <option value="0">0</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                        </select>
                      </td>
                      <td>{this.state.orderDates[editIndex].slot5TotalCapacity}</td>
                    </tr>
                  </tbody>
                </Table>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={this.toggleEditSlotModal}>
                  Save
                </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }

    let dayPicker = null;
    if (this.state.frequency === "Single") {
		if(this.props.userRole =='Super Admin' ||  this.props.userRole =='Administrator' || this.props.userRole =='Support User' || this.props.userRole =='CRE' || this.props.userRole =='Logistics') { 
		  dayPicker = (
			<DayPicker
			  numberOfMonths={2}
			  //disabledDays={[{ before: new Date() }]}
			  selectedDays={this.state.selectedDay}
			  onDayClick={this.handleDayClick}
			/>
		  );
		}else{
		dayPicker = (
			<DayPicker
			  numberOfMonths={2}
			  disabledDays={[{ before: new Date() }]}
			  selectedDays={this.state.selectedDay}
			  onDayClick={this.handleDayClick}
			/>
		);

		}
    } else if (this.state.frequency === "Recurring") {

      const today = new Date();
      const tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + 1)
      dayPicker = (

        <DayPicker
          className="Range"
          numberOfMonths={2}
          disabledDays={[{ before: tomorrow }, { before: from }]}
          selectedDays={[from, { from, to }]}
          modifiers={modifiers}
          onDayClick={this.handleRecurringDayClick}
        />

      );
    } else if (this.state.frequency === "Custom") {
      dayPicker = (
        <DayPicker
          numberOfMonths={2}
          disabledDays={[new Date(), { before: new Date() }]}
          selectedDays={this.state.multipleDays}
          modifiers={modifiers}
          onDayClick={this.handleMultipleDayClick}
        />
      );
    } else {
      dayPicker = (
        <DayPicker
          numberOfMonths={2}
          disabledDays={[new Date(), { before: new Date() }]}
          style={{ width: "100%" }}
        ></DayPicker>
      );
    }

    let orders = null;
    if (this.state.generateOrder === "Y") {
      orders = (
        <Table striped bordered hover >
          <thead align="center">
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Slot1</th>
              <th>Slot2</th>
              <th>Slot3</th>
              <th>Slot4</th>
              <th>Slot5</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody align="center">
            {this.state.orderDates.map((orderDate, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{dateFormat(orderDate.orderDate, 'dd-mm-yyyy')}</td>
                <td>
                  {orderDate.slot1Capacity}*{orderDate.slot1Quantity}=
                    {orderDate.slot1TotalCapacity}
                </td>
                <td>
                  {orderDate.slot2Capacity}*{orderDate.slot2Quantity}=
                    {orderDate.slot2TotalCapacity}
                </td>
                <td>
                  {orderDate.slot3Capacity}*{orderDate.slot3Quantity}=
                    {orderDate.slot3TotalCapacity}
                </td>
                <td>
                  {orderDate.slot4Capacity}*{orderDate.slot4Quantity}=
                    {orderDate.slot4TotalCapacity}
                </td>
                <td>
                  {orderDate.slot5Capacity}*{orderDate.slot5Quantity}=
                    {orderDate.slot5TotalCapacity}
                </td>
                <td>
                  <ButtonGroup aria-label="Basic example">
                    <Button variant="outline-warning" onClick={() => this.editSlotHandler(index)}>
                      Edit
                    </Button> &nbsp;&nbsp;&nbsp;&nbsp;
                   

{(this.state.orderDates.length <= 1  ? ""
                   : (<Button disabled={this.state.orderDates.length <= 1} variant="outline-danger" onClick={() => this.deletSlotHandler(index)}>Delete</Button>
) )
}
                   </ButtonGroup>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      );
    }

    // let customerData = "";
    // if (customerType === "Apartment_Customer") {
    //   customerData = this.state.apartmentUserInput.map((data, index) => (
    //     <option key={index} value={data.apartmentId + "&&" + data.apartmentName}>{data.apartmentName}</option>
    //   ))
    // } else if (customerType === "Corporate_Customer") {
    //   customerData = this.state.corporateUserInput.map((data, index) => (
    //     <option key={index} value={data.corporateId + "&&" + data.companyName}>{data.companyName}</option>
    //   ))
    // }

    let customerData1 = [];
    if (customerType === "Apartment_Customer") {
      this.state.apartmentUserInput.map(data => {
		 if(data.user !== undefined && data.user !== null){
			let sddData = { id: "customerCode", label: data.user.userFirstName +" "+ data.user.userLastName +" ("+data.apartmentId+")", value: data.apartmentId + "&&" + data.apartmentName }
				customerData1.push(sddData)
		 }else{
			 let sddData = { id: "customerCode", label: data.apartmentName +" ("+data.apartmentId+")", value: data.apartmentId + "&&" + data.apartmentName }
			 customerData1.push(sddData)
		 }
        
        
        return null;
      })
    } else if (customerType === "Corporate_Customer") {
      this.state.corporateUserInput.map(data => {
		  // console.log(data)
        let sddData = { id: "customerCode", label: data.companyName+" ("+data.corporateId+")", value: data.corporateId + "&&" + data.companyName }
        customerData1.push(sddData)
        return null;
      })
    } else if (customerType === "Individual_Customer") {
      this.state.individualUserInput.map(data => {
		   // console.log(data)
			let sddData = { id: "customerCode", label: data.firstName +" "+ data.lastName +" ("+data.individualId+")", value: data.individualId + "&&" + data.name }
			customerData1.push(sddData)				
        return null;
      })
    } 

    let customerTypeData = [
      { id: "customerType", label: "Apartment Customer", value: "Apartment_Customer" },
           { id: "customerType", label: "Individual Customer", value: "Individual_Customer" },
      { id: "customerType", label: "Corporate Customer", value: "Corporate_Customer" }]

    let customerTypeSelection = "";
    let pricePerKL = "";
    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole =='CRE' || this.props.userRole =='Logistics') {
      customerTypeSelection = (
        <Form.Row>
          <Form.Group as={Col} controlId="customerType">
            <Form.Label>Customer Type</Form.Label>
            <Select id="customerType" styles={selectStyles} options={customerTypeData} onChange={this.handleSelectFormFields} />
            {
              this.validator.message('Customer Type', this.state.customerType, 'required')
            }
          </Form.Group>
          <Form.Group as={Col} controlId="id">
            <Form.Label>Customer</Form.Label>
            <Select value={this.state.customerSelect} styles={selectStyles} options={customerData1} onChange={this.handleSelectFormFields} />
            {
              this.validator.message('Customer Name', this.state.customerName, 'required')
            }

          </Form.Group>
          {/* <Form.Group>
            <Form.Label>Marketting Manager Id</Form.Label>
            <Form.Control
              type="text"
              placeholder="Marketting Manager Id"
            ></Form.Control>
          </Form.Group> */}
        </Form.Row>
      )
      pricePerKL = <><Form.Label><b> Price per KL :</b></Form.Label>
        <Form.Control
          type="text" name="contractPricePerKL"
          value={this.state.pricePerKL} disabled
        //onChange={this.handleFormFields}
        ></Form.Control></>
    }

    let totalOrderQuantum = 0;
    if (this.state.slot1TotalCapacity === 0 && this.state.slot2TotalCapacity === 0 && this.state.slot3TotalCapacity === 0
      && this.state.slot4TotalCapacity === 0 && this.state.slot5TotalCapacity === 0) {
      totalOrderQuantum = 0;
    }
    else {
      totalOrderQuantum = this.state.slot1TotalCapacity + this.state.slot2TotalCapacity + this.state.slot3TotalCapacity +
        this.state.slot4TotalCapacity + this.state.slot5TotalCapacity
    }

    const checkboxes = [
      {
        name: 'SUNDAY',
        key: 'SUNDAY',
        label: 'Every Sunday',
      },
      {
        name: 'MONDAY',
        key: 'MONDAY',
        label: 'Every Monday',
      },
      {
        name: 'TUESDAY',
        key: 'TUESDAY',
        label: 'Every Tuesday',
      },
      {
        name: 'WEDNESDAY',
        key: 'WEDNESDAY',
        label: 'Every Wednesday',
      },
      {
        name: 'THURSDAY',
        key: 'THURSDAY',
        label: 'Every Thursday',
      },
      {
        name: 'FRIDAY',
        key: 'FRIDAY',
        label: 'Every Friday',
      },
      {
        name: 'SATURDAY',
        key: 'SATURDAY',
        label: 'Every Saturday',
      },
      {
        name: 'ALTERNATEDAY',
        key: 'ALTERNATEDAY',
        label: 'Every Alternate Days',
      }
    ];
    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item active>Book Water</Breadcrumb.Item>
        </Breadcrumb>

        <div>
          <Card>
            <Card.Body>
              {customerTypeSelection}
              <Form>
                <Form.Row>
                  <Form.Group className="col-md-6"
                    as={Col}
                    controlId="address" >
                    <Form.Label>Address</Form.Label>
                    <Form.Control as="select"
                      value={this.state.label}
                      onChange={this.handleFormFields}>
                      {
                        this.state.AddressIdInput.map((data, index) => {
                          if (this.state.AddressIdInput.length - 1 === index) {
                            return (<option selected key={index} value={data.id + "&&" + data.label + "&&" + data.fullAddress + "&&" + data.pricePerKL+ "&&"+ data.CPtoDate+ "&&"+ data.CPfromDate}>{data.label}</option>)
                          } else {
                            return (<option key={index} value={data.id + "&&" + data.label + "&&" + data.fullAddress + "&&" + data.pricePerKL+ "&&"+ data.CPtoDate+ "&&"+ data.CPfromDate}>{data.label}</option>)
                          }
                        })
                      }
                    </Form.Control>
                    {
                      this.validator.message('Address Id', this.state.fullAddress, 'required')
                    }
                  </Form.Group>
                   <Form.Group className="col-md-6"
                    as={Col}
                    controlId="tds" style={{display:this.state.canshowtds}}>
                    <Form.Label>TDS</Form.Label>
                    <Form.Control as="select"
                      value={this.state.tds}
                      onChange={this.handleFormFields}>
                      {
                        this.state.AddressIdInput.map((data, index) => {
							if (this.state.AddressIdInput.length - 1 === index) {
								if(data.showtocustomer === 'Yes'){
									return (<option selected key={index} value={data.id + "&&" + data.label + "&&" + data.fullAddress + "&&" + data.pricePerKL+ "&&"+ data.CPtoDate+ "&&"+ data.CPfromDate}>{data.tds}</option>)
								}
							} else {
								if(data.label === 'Choose'){
									return (<option key={index} value={data.id + "&&" + data.label + "&&" + data.fullAddress + "&&" + data.pricePerKL+ "&&"+ data.CPtoDate+ "&&"+ data.CPfromDate}>Choose</option>)
								}else{
									if(data.showtocustomer === 'Yes'){
										return (<option key={index} value={data.id + "&&" + data.label + "&&" + data.fullAddress + "&&" + data.pricePerKL+ "&&"+ data.CPtoDate+ "&&"+ data.CPfromDate}>{data.tds}</option>)
									}
								}
							}
                        })
                      }
                    </Form.Control>
                  </Form.Group>
					<Form.Group controlId="fullAddress" className="col-lg-6" style={{display:this.state.canshowaddressintdsplace}}>
						<Form.Label>Delivery Address</Form.Label>
						<Form.Control
						  as="textarea"
						  value={this.state.fullAddress}
						  onChange={this.handleFormFields}
						  rows="3" />
					</Form.Group>
                </Form.Row>
				<Form.Row>
					<Form.Group controlId="fullAddress" className="col-lg-6"  style={{display:this.state.canshowaddressinoutsideplace}}>
						<Form.Label>Delivery Address</Form.Label>
						<Form.Control
						  as="textarea"
						  value={this.state.fullAddress}
						  onChange={this.handleFormFields}
						  rows="3" />
						</Form.Group>
				</Form.Row>
                {newAddress}
                <Form.Row>
                  <Form.Group as={Col} controlId="frequency">
                    <Form.Label>Frequency</Form.Label>
                    <Form.Control
                      as="select"
                      value={this.state.frequency}
                      onChange={this.handleFormFields} >
                      <option>Choose...</option>
                      <option>Single</option>
                      <option>Recurring</option>
                      <option>Custom</option>
                    </Form.Control>
                    {
                      this.validator.message('Order Frequency', this.state.frequency, 'required')
                    }
                    {dayPicker}
                    <div>
                      {(this.state.frequency === "Recurring" ? checkboxes.map(item => (
                        <label key={item.key}>

                          <input type="checkbox" name={item.name} checked={this.state.checkedItems.get(item.name)} onChange={this.handleChange} />

                          {item.label}
                        </label>
                      )) : "")
                      }
                    </div>
                    {
                      this.validator.message('Order Date', this.state.selectedDay || this.state.from || this.state.multipleDays, 'required')
                    }
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label>Slots</Form.Label>
                    <Table bordered hover>
                      <thead align="center">
                        <tr >
                          <th>Slots</th>
                          <th>Quantum </th>
                          <th>Quantity</th>
                          <th>Total Quantity </th>
                        </tr>
                      </thead>
                      <tbody align="center">
                        <tr>
                          <td>Slot 1(8pm-12am)</td>
                          <td>
                            <select id='slot1Capacity' disabled={this.state.slot1Disable} className="form-control" value={this.state.slot1Capacity} onChange={this.handleFormFields} >
                              <option value="12000">12Kl</option>
                              <option value="24000">24Kl</option>
                              <option value="36000">36Kl</option>
                              <option value="48000">48Kl</option>
                            </select>
                          </td>
                          <td>
                            <select className="form-control" disabled={this.state.slot1Disable} id="slot1Quantity" value={this.state.slot1Quantity} onChange={this.handleFormFields}>
                              <option value="0">0</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                            </select>
                          </td>
                          <td>{this.state.slot1TotalCapacity}</td>
                        </tr>
                        <tr >
                          <td>Slot 2(12am-4am)</td>
                          <td>
                            <select id='slot2Capacity' disabled={this.state.slot2Disable} className="form-control" value={this.state.slot2Capacity} onChange={this.handleFormFields} >
                              <option value="12000">12Kl</option>
                              <option value="24000">24Kl</option>
                              <option value="36000">36Kl</option>
                              <option value="48000">48Kl</option>
                            </select>
                          </td>
                          <td>
                            <select className="form-control" disabled={this.state.slot2Disable} id="slot2Quantity" value={this.state.slot2Quantity} onChange={this.handleFormFields}>
                              <option value="0">0</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                            </select>
                          </td>
                          <td>{this.state.slot2TotalCapacity}</td>
                        </tr>
                        <tr >
                          <td>Slot 3(4am-8am)</td>
                          <td>
                            <select id='slot3Capacity' disabled={this.state.slot3Disable} className="form-control" value={this.state.slot3Capacity} onChange={this.handleFormFields} >
                              <option value="12000">12Kl</option>
                              <option value="24000">24Kl</option>
                              <option value="36000">36Kl</option>
                              <option value="48000">48Kl</option>
                            </select>
                          </td>
                          <td>
                            <select className="form-control" disabled={this.state.slot3Disable} id="slot3Quantity" value={this.state.slot3Quantity} onChange={this.handleFormFields}>
                              <option value="0">0</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                            </select>
                          </td>
                          <td>{this.state.slot3TotalCapacity}</td>
                        </tr>
                        <tr>
                          <td>Slot 4(8am-2pm)</td>
                          <td>
                            <select id='slot4Capacity' disabled={this.state.slot4Disable} className="form-control" value={this.state.slot4Capacity} onChange={this.handleFormFields} >
                              <option value="12000">12Kl</option>
                              <option value="24000">24Kl</option>
                              <option value="36000">36Kl</option>
                              <option value="48000">48Kl</option>
                            </select>
                          </td>
                          <td>
                            <select className="form-control" disabled={this.state.slot4Disable} id="slot4Quantity" value={this.state.slot4Quantity} onChange={this.handleFormFields}>
                              <option value="0">0</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                            </select>
                          </td>
                          <td>{this.state.slot4TotalCapacity}</td>
                        </tr>
                        <tr>
                          <td>Slot 5(2pm-8pm)</td>
                          <td>
                            <select id='slot5Capacity' disabled={this.state.slot5Disable} className="form-control" value={this.state.slot5Capacity} onChange={this.handleFormFields} >
                              <option value="12000">12Kl</option>
                              <option value="24000">24Kl</option>
                              <option value="36000">36Kl</option>
                              <option value="48000">48Kl</option>
                            </select>
                          </td>
                          <td>
                            <select className="form-control" disabled={this.state.slot5Disable} id="slot5Quantity" value={this.state.slot5Quantity} onChange={this.handleFormFields}>
                              <option value="0">0</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                            </select>
                          </td>
                          <td>{this.state.slot5TotalCapacity}</td>
                        </tr>
                      </tbody>
                    </Table>
                    {this.validator.message('Order Total Capacity', totalOrderQuantum, 'required|integer|min:12000,num')}
                  </Form.Group>
                </Form.Row>
                {editSlots}
                <Form.Row>
                  <Form.Group as={Col}>{pricePerKL}</Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label><b> Total Estimation :</b></Form.Label>
                    <Form.Control
                      type="text" name="contractPricePerKL"
                      value={this.state.totalOrderPrice} disabled
                    //onChange={this.handleFormFields}
                    ></Form.Control>
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <ButtonToolbar style={{ marginLeft: "5px", marginBottom: "10px" }}>
                    <Button
                      variant="outline-primary"
                      onClick={this.generateOrderEventHandler}
                      disabled={this.state.generateButtonFlag}>
                      Generate
                    </Button>
                  </ButtonToolbar>
                </Form.Row>
                {orders}
				
			{ this.props.userRole === 'Apartment Customer' ? (   (customerType === "Apartment_Customer" && this.state.totalOrderPrice !== 0  ? (
                        <label> 

                          <input type="checkbox" value={'paynow'}  onChange={this.handleChange} />
                          <span style={{ padding:"2px 2px" }}>Pay Now</span>
                        </label>
			)   : "") ) : "" }
			
			{ (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole =='CRE' || this.props.userRole =='Logistics') ? (   (customerType === "Apartment_Customer"  ? (
                        <label> 

                          <input type="checkbox" value={'paynow'}  defaultChecked={this.state.chkbox}  onChange={this.handleChange} />
                          <span style={{ padding:"2px 2px" }}>Pay Now</span>
                        </label>
			)   : "") ) : "" }
			
			
					
                <ButtonToolbar style={{ marginTop: "10px" }}>
                  <Button
                    variant="outline-success"
                    onClick={this.createOrder}
                    disabled={this.state.disableSubmit && this.state.orderDates !== []}>
                    Submit
                  </Button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Button
                    variant="outline-warning"
                    onClick={() => this.nextPath("/transaction/order/order-list")}>
                    Back
                  </Button>
                </ButtonToolbar>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </>
    );
  }
}


const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id,
    userfirstname : state.auth.user[0].userFirstName,
    userlastname: state.auth.user[0].userLastName,
	mobiledevice: state.auth.user[0].mobiledeviceId,

  }
}

export default connect(
  mapStateToProps,
  null
)(CreateOrder)

